import { z } from "zod";
import { TypePays } from "../enums/type-pays.enum";

export const sabonnerFormSchema = z
  .object({
    civiliteId: z.string(),
    siret: z.string(),
    nom: z.string().min(1, "Requis"),
    prenom: z.string().min(1, "Requis"),
    dateDeNaissance: z.string(),
    adresse1: z.string().min(1, "Requis"),
    adresse2: z.string(),
    codePostal: z.string().min(1, "Requis"),
    ville: z.string().min(1, "Requis"),
    telephone: z.string().min(1, "Requis"),
    typePays: z.string().min(1, "Requis"),
    pays: z.string(),
    raisonSociale: z.string(),
    personneMorale: z.boolean(),
    envoyerAdresseDifferente: z.boolean(),
    nomLivraison: z.string(),
    entrepriseLivraison: z.string(),
    adresse1Livraison: z.string(),
    adresse2Livraison: z.string(),
    codePostalLivraison: z.string(),
    villeLivraison: z.string(),
    paysLivraison: z.string(),
    typePaysLivraison: z.string(),
    nbRuches: z.coerce.number({ invalid_type_error: "Doit être un chiffre" }).int("Nombre entier requis"),
  })
  .superRefine((data, ctx) => {
    if (data.envoyerAdresseDifferente && !data.nomLivraison && !data.entrepriseLivraison) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Nom ou entreprise de livraison requis",
        path: ["entrepriseLivraison"],
      });
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Nom ou entreprise de livraison requis",
        path: ["nomLivraison"],
      });
    }
    if (!data.personneMorale && !data.dateDeNaissance) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Requis",
        path: ["dateDeNaissance"],
      });
    }
    if (data.personneMorale && !data.raisonSociale) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Requis",
        path: ["raisonSociale"],
      });
    }
    if (!data.personneMorale && !data.civiliteId) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Requis",
        path: ["civiliteId"],
      });
    }
    if (data.typePays === TypePays.FRANCE && data.codePostal.trim().length < 5) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Un code postal français doit faire 5 caractères",
        path: ["codePostal"],
      });
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Valeur incohérente avec le code postal",
        path: ["typePays"],
      });
    }
    if (
      data.envoyerAdresseDifferente &&
      data.typePaysLivraison === TypePays.FRANCE &&
      data.codePostal.trim().length < 5
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Un code postal français doit faire 5 caractères",
        path: ["codePostalLivraison"],
      });
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Valeur incohérente avec le code postal",
        path: ["typePaysLivraison"],
      });
    }
  });
